import { ISwitcherOption } from '@common/components/Switcher/Switcher';
import { documentTypeToCustomLabelMap } from '@common/constants';
import { DocumentType } from '@common/types';

export const CONTENT_TABS: ISwitcherOption[] = [
  { value: DocumentType.Smpc, label: documentTypeToCustomLabelMap.SmPC },
  { value: DocumentType.Pil, label: documentTypeToCustomLabelMap.PIL },
];
